export default {
  noTransactions: 'There are no transactions for the selected period',
};
